<template>
  <div id="bloco-detalhes" :class="{'d-flex bra-8': !VISAO_VERTICAL_ATIVA}">
    <DetalhesProduto v-if="PRODUTO_SELECIONADO.idproduto" />

    <template v-else>
      <MovimentacoesEstoque
        :update_resize="Number(VISAO_VERTICAL_ATIVA)"
        :class="CLASSES_CSS_MOVIMENTACOES_ESTOQUE"
        :filtros="FILTROS_STORE"
      />

      <v-divider :vertical="!VISAO_VERTICAL_ATIVA" />

      <RupturaEstoque :class="CLASSES_CSS_RUPTURA_ESTOQUE" />
    </template>
  </div>
</template>

<script>
import MovimentacoesEstoque from "@/components/compra/ProdutosGerais/Indicadores/MovimentacaoEstoque";
import RupturaEstoque from "@/components/compra/ProdutosGerais/Indicadores/RupturaEstoque";
import DetalhesProduto from "@/components/compra/ProdutosGerais/DetalhesProduto/Index.vue";

export default {
  name: "Detalhes",
  components: {
    RupturaEstoque,
    MovimentacoesEstoque,
    DetalhesProduto
  },
  computed: {
    VISAO_VERTICAL_ATIVA() {
      return this.$store.getters['CompraProdutosGerais/getVisaoVertical'];
    },
    PRODUTO_SELECIONADO() {
      return this.$store.getters['CompraProdutosGerais/getProdutoSelecionado'];
    },
    CLASSES_CSS_MOVIMENTACOES_ESTOQUE() {
      return {
        'pt-3': true,
        'visao-vertical-detalhes-geral': this.VISAO_VERTICAL_ATIVA,
        'visao-horizontal-detalhes-geral pr-3': !this.VISAO_VERTICAL_ATIVA,
      };
    },
    CLASSES_CSS_RUPTURA_ESTOQUE() {
      return {
        'visao-vertical-detalhes-geral': this.VISAO_VERTICAL_ATIVA,
        'visao-horizontal-detalhes-geral pl-2': !this.VISAO_VERTICAL_ATIVA,
      };
    },
    FILTROS_STORE() {
      return this.$store.getters["CompraProdutosGerais/getFiltrosGerais"]
    },
  }
}
</script>

<style scoped>
#bloco-detalhes {
  background: #FFFFFF;
  box-shadow: 0 1px 2px rgba(181, 181, 181, 0.82);
}
.visao-vertical-detalhes-geral {
  height: 50%;
  width: 100%;
}
.visao-horizontal-detalhes-geral {
  height: 100%;
  width: 50%;
}
</style>
